import lang from 'lang'
import settingsConfig from '@/modules/settings/config'
import request from '@/modules/base/util/request'

import { toast } from '@/modules/base/components/toast/toastConfig'

// actions

const actionPrefix = 'SHIPPING/SHIPMENTTYPES/'
const LOADED = `${actionPrefix}LOADED`

// reducer
const initialState = {
  isLoading: false,
  shipmentTypes: [],
  defaultShipmentType: {},
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOADED:
      const { shipmentTypes } = action
      const defaultShipmentType = shipmentTypes.find(item => item.isDefault)
      return { ...state, shipmentTypes, defaultShipmentType }

    default:
      return state
  }
};

export const loaded = (shipmentTypes) => {
  return {
    type: LOADED,
    shipmentTypes,
  }
}

export const loadShipmentTypes = () => {
  return (dispatch) => {
    request(settingsConfig.shipmentType,
      { auth: true, method: 'GET' })
      .then((result) => {
        const { body: { data: shipmentTypes } } = result
        dispatch(loaded(shipmentTypes))
      })
      .catch(() => {
        toast.showToast({ type: 'error', message: lang.defaultErrorMessage })
      })
  }
}
